import { render, staticRenderFns } from "./NoticeScroll.vue?vue&type=template&id=a7aed316&scoped=true&"
import script from "./NoticeScroll.vue?vue&type=script&lang=js&"
export * from "./NoticeScroll.vue?vue&type=script&lang=js&"
import style0 from "./NoticeScroll.vue?vue&type=style&index=0&id=a7aed316&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7aed316",
  null
  
)

export default component.exports